import React from "react";
import apiProxy from "../../api/apiProxy";
import LightingStatusPage from "./LightingStatusPage";

export default props => (
  <LightingStatusPage getStatus={apiProxy.storeLighting.getStatus} />
);
